var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E5F0",
    d: "M0 0h20v20H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#OBPlus_svg__filter0_d_182_13696)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "OBPlus_svg__a",
    maskUnits: "userSpaceOnUse",
    x: -684,
    y: -20,
    width: 725,
    height: 532,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-684-20H41v532h-725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-682-2c0-8.837 7.163-16 16-16H22c8.837 0 16 7.163 16 16v514h-720V-2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-682-2c0-8.837 7.163-16 16-16H22c8.837 0 16 7.163 16 16v514h-720V-2z",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-282-18H22c8.837 0 16 7.163 16 16v514h-320V-18z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10a1 1 0 01-1 1H4a1 1 0 110-2h12a1 1 0 011 1z",
    fill: "#111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-684-2c0-9.941 8.059-18 18-18H22c9.941 0 18 8.059 18 18h-4c0-7.732-6.268-14-14-14h-688c-7.732 0-14 6.268-14 14h-4zM38 512h-720H38zm-722 0V-2c0-9.941 8.059-18 18-18v4c-7.732 0-14 6.268-14 14v514h-4zM22-20c9.941 0 18 8.059 18 18v514h-4V-2c0-7.732-6.268-14-14-14v-4z",
    fill: "#AAA",
    mask: "url(#OBPlus_svg__a)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "OBPlus_svg__filter0_d_182_13696",
    x: -724,
    y: -60,
    width: 804,
    height: 1031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_182_13696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_182_13696",
    result: "shape"
  })))));
}

export default SvgObPlus;